import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AutotextService } from '../autotext.service';
import { ExamsService } from '../exams.service';
import { AutoTextUUIDs } from '../interfaces/autotext.service/uids';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ovarian-doppler',
  templateUrl: './ovarian-doppler.component.html',
  styleUrls: ['./ovarian-doppler.component.scss'],
  standalone: false,
})
export class OvarianDopplerComponent implements OnInit {
  dopplerForm: UntypedFormGroup;
  AutoTextUUIDs = AutoTextUUIDs;
  mediaSub: Subscription;
  formSub: Subscription;
  ovaryChangeSub: Subscription;

  constructor(
    public atS: AutotextService,
    public es: ExamsService,
    private fb: UntypedFormBuilder
  ) {
    this.dopplerForm = this.fb.group({
      LObserved: [''],
      LSizeX: [''],
      LSizeY: [''],
      LSizeZ: [''],
      LSizeVol: [''],
      LPI: [''],
      LPIStatus: [''],
      LRI: [''],
      LRIStatus: [''],
      LSD: [''],
      LSDStatus: [''],
      RObserved: [''],
      RSizeX: [''],
      RSizeY: [''],
      RSizeZ: [''],
      RSizeVol: [''],
      RPI: [''],
      RPIStatus: [''],
      RRI: [''],
      RRIStatus: [''],
      RSD: [''],
      RSDStatus: [''],
      Fluid: [''],
      POD: [''],
      Comments: [''],
      LComments: [''],
      RComments: [''],
      DiagnosisCodes: [''],
      Diagnosis: [''],
      LOvarianCystObserved: [''],
      ROvarianCystObserved: [''],
      LAFC: [''],
      RAFC: [''],
      LFallopianTubeObserved: [''],
      RFallopianTubeObserved: [''],
      LOvaryComments: [''],
      ROvaryComments: [''],
      LDopplerComments: [''],
      RDopplerComments: [''],
    });
  }

  ngOnInit(): void {
    this.es.fillForm(this.dopplerForm, 'adnexa', false, true);
    this.es.getSRs();
    if (!this.es.isClosed)
      this.mediaSub = this.es.mediaArrived$.subscribe((mediatype) => {
        if (mediatype == 'html') this.es.fillForm(this.dopplerForm, 'adnexa', false, true);
      });
  }

  setN(side: string, val: string) {
    this.dopplerForm.get(side + 'Observed').setValue(val);
  }

  reset(item: string) {
    if (!this.es.isClosed) {
      this.dopplerForm.get(item).setValue(-1);
    }
  }

  ngOnDestroy() {
    if (this.formSub) {
      this.formSub.unsubscribe();
    }
    if (this.mediaSub) {
      this.mediaSub.unsubscribe();
    }
    if (this.ovaryChangeSub) {
      this.ovaryChangeSub.unsubscribe();
    }
  }
}
